import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import About from '@/views/About'

Vue.use(Router)

export const routerMap = [
    {
        path: '/',
        component: Home,
    }, {
        path: '/About',
        component: About,
    }
]

const router = new Router({
    routes: routerMap
})

export default router